import { render, staticRenderFns } from "./viewMessageConfig.vue?vue&type=template&id=422bdc6f&"
import script from "./viewMessageConfig.vue?vue&type=script&lang=js&"
export * from "./viewMessageConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VForm,VRow,VSelect,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422bdc6f')) {
      api.createRecord('422bdc6f', component.options)
    } else {
      api.reload('422bdc6f', component.options)
    }
    module.hot.accept("./viewMessageConfig.vue?vue&type=template&id=422bdc6f&", function () {
      api.rerender('422bdc6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/MessageConfig/components/viewMessageConfig.vue"
export default component.exports